var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCancel(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_25596)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.99922 2.8002C5.12734 2.8002 2.79922 5.12831 2.79922 8.0002C2.79922 10.8721 5.12734 13.2002 7.99922 13.2002C10.8711 13.2002 13.1992 10.8721 13.1992 8.0002C13.1992 5.12831 10.8711 2.8002 7.99922 2.8002ZM1.19922 8.0002C1.19922 4.24466 4.24368 1.2002 7.99922 1.2002C11.7548 1.2002 14.7992 4.24466 14.7992 8.0002C14.7992 11.7557 11.7548 14.8002 7.99922 14.8002C4.24368 14.8002 1.19922 11.7557 1.19922 8.0002Z",
    fill: "#353535"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.56496 3.43457L12.565 11.4346L11.4336 12.5659L3.43359 4.56594L4.56496 3.43457Z",
    fill: "#353535"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_25596"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCancel);
export default __webpack_public_path__ + "static/media/cancel.ee3ed62ee837eedeaf6ffa106e81bf7b.svg";
export { ForwardRef as ReactComponent };